import {ProgressMainStage} from '@/app/models/progress-main-stage.enum';

export const PROGRESS_MAIN_STAGES_ORDER: Array<ProgressMainStage> = [
  ProgressMainStage.begin,
  ProgressMainStage.form,
  ProgressMainStage.generator,
  ProgressMainStage.summary,
  ProgressMainStage.contact,
];
